'use client';

import { c as _c } from "react/compiler-runtime";
import type { Address, ChainId } from '@morpho-org/blue-sdk';
import SectionErrorBoundary from '@/components/common/SectionErrorBoundary';
import RiskDisclosureClient from './RiskDisclosure/RiskDisclosure.client';
import { RiskDisclosureError } from './RiskDisclosure/states';
import { VaultRiskDisclosuresLayout } from './VaultRiskDisclosuresLayout';
export interface VaultRiskDisclosuresClientProps {
  address: Address;
  chainId: ChainId;
}
const VaultRiskDisclosuresClient = t0 => {
  const $ = _c(4);
  const {
    address,
    chainId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <RiskDisclosureError />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== address || $[2] !== chainId) {
    t2 = <VaultRiskDisclosuresLayout><SectionErrorBoundary fallback={t1}><RiskDisclosureClient address={address} chainId={chainId} /></SectionErrorBoundary></VaultRiskDisclosuresLayout>;
    $[1] = address;
    $[2] = chainId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default VaultRiskDisclosuresClient;